import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LabelItem from '../LabelItem';
import ListItem from '../ListItem';
import { ReactComponent as SubscriptionIcn } from '../../../../icons/subscription-icon.svg';
import getColorClasses from '../../lib/getColorClasses';

const Subscription = ({ currentPath }) => {
  const { t } = useTranslation('PAGES');
  const validPaths = ['/app/subscription'];

  return (
    <ListItem>
      <Link to="/app/subscription" className="flex">
        <SubscriptionIcn className={getColorClasses(currentPath, validPaths)} />
        <LabelItem className={getColorClasses(currentPath, validPaths)}>{t('SUBSCRIPTION')}</LabelItem>
      </Link>
    </ListItem>
  );
};

export default Subscription;
